const initialState = {
    dataPolicies: []
}

const policiesReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FETCH_POLICIES':
            return {
                ...state,
                dataPolicies: action.payload
            }
        default:
            return state
    }
}

export default policiesReducer
